"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_TREE_NODES_PRODUCT_PRESENTATIONS_SHORT = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.GET_PRODUCT_TREE_NODES_PRODUCT_PRESENTATIONS_SHORT = (0, gql_1.gql)(`
  query ProductTreeNodesProductPresenationShort($ancestralProductTreeId: ID!, $filter: ProductTreeNodeFilter, $catalog: ID!) {
    productTreeNodes(ancestralProductTreeId: $ancestralProductTreeId, filter: $filter) {
      edges {
        node {
          productPresentationsNew(catalog: $catalog) {
            totalCount
          }
          title,
          id
        }
      }
    }
}
`);
